<div class="overlay"></div>

<div class="payment-date-panel">
  <mat-card style="padding: 20px; border-radius: 20px">
    <mat-card-header>
      <mat-card-title>Modifica data pagamento</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-form-field>
        <mat-label>Data pagamento</mat-label>
        <input matInput [matDatepicker]="picker" [(ngModel)]="newPaymentDate" />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="picker"
        ></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </mat-card-content>
    <mat-card-actions style="justify-content: space-around">
      <button
        mat-button
        class="button-white"
        style="padding: 10px"
        (click)="close()"
      >
        Annulla
      </button>
      <button
        mat-raised-button
        class="button-white"
        style="padding: 10px"
        (click)="confirm()"
      >
        Conferma
      </button>
    </mat-card-actions>
  </mat-card>
</div>
